import { FormFooterProps } from '@/types/form/form-props';
import { Button } from '../button';
import { LoadingButton } from '../buttons/loading-button';
import { DialogClose, DialogFooter } from '../dialog';

export function DialogFormFooter({ isSubmitting, canSubmit, submitText = 'Spara', resetText = 'Avbryt' }: FormFooterProps) {
  return (
    <DialogFooter className="border-t pt-4 -mx-6 px-6">
      <DialogClose asChild>
        <Button type="reset" variant="outline">
          {resetText}
        </Button>
      </DialogClose>
      <LoadingButton disabled={!canSubmit} isLoading={isSubmitting} type="submit">
        {submitText}
      </LoadingButton>
    </DialogFooter>
  );
}
